{
  "replaceMessage": "שחרר את הקובץ להחלפה"
}
